export const planningQuestions: string[] = [
  'What should I teach next?',
  'How should I explain this skill?',
  'What progression should I use?',
  "How do I correct this student's buoyancy?",
  'What should they master before moving forward?',
]

export const notBecause: string[] = ["Not because you don't know how to teach scuba."]

export const scratchHabits: string[] = [
  'You search for drills.',
  'You recreate explanations.',
  'You repeat whatever worked last time.',
  'You improvise progressions.',
  'You try to explain trim, buoyancy or underwater positioning again using only words.',
  'You build another assessment.',
  'You decide what the student should practice next.',
]

export const painPoints: string[] = [
  'Hours spent preparing scuba lessons.',
  'Disconnected training activities.',
  'Repeating the same explanations because they are easiest to remember.',
  'Students developing without a clear progression.',
  'Complex underwater skills explained differently every time.',
  'No consistent error-correction system.',
  'No simple way to track progress.',
  'More time planning and less time teaching.',
  'Entering the session with an idea instead of a complete structure.',
]
